<template>
  <tr>
    <td>
      <div class="checkbox checkbox-primary">
        <input :disabled="!canManageTag" :id="`tag-${tag.id}`" class="styled" type="checkbox" v-model="selected" />
        <label :for="`tag-${tag.id}`"></label>
      </div>
    </td>
    <td class="tag-name">
      <label :for="`tag-${tag.id}`">{{ tag.name }}<span v-if="tag.group" class="tag-group"> - {{ tag.group }}</span></label>
    </td>
    <td>{{ tag.occurrences ? tag.occurrences : 0 }}</td>
    <td>
      <a v-if="canManageTag" href="" @click.prevent="handleDeleteTag" class="remove"><i class="fa fa-minus-circle"></i></a>
      <span v-else class="disabled"><i class="fa fa-minus-circle"></i></span>
    </td>
    <td v-if="hasEdit">
      <router-link v-if="canManageTag" :to="{ name: 'system.tag', params: { id: tag.id, tagType: tag.tag_type} }" class="manage-tag">
        <i class="fa fa-fw fa-pencil-square-o" /> Edit
      </router-link>
      <div v-else class="disabled manage-tag">
        <i class="fa fa-fw fa-pencil-square-o" /> Edit
      </div>
    </td>
  </tr>
</template>

<style scoped>
  .tag-name label {
    font-weight: normal;
    margin: 0;
  }
</style>

<script>
import { clone, findIndex } from 'lodash'

export default {
  props: {
    value: {
      required: false,
      default () {
        return []
      }
    },
    tag: {
      required: true,
      type: Object
    },
    hasEdit: {
      required: true,
      type: Boolean
    }
  },

  watch: {
    /**
     * Watch changes to the parent value, if it changes, and this tag is no longer in the array
     * of selected tags then we'll set "selected" for this tag to false.
     *
     * @return void
     */
    value () {
      let existingIndex = findIndex(this.value, existing => existing.id === this.tag.id)

      if (existingIndex === -1 && this.selected) {
        this.selected = false
      }
    },

    /**
     * Watch the selected prop and when it changes we'll mutate a new clone of the value
     * passed in and push the array back up. This let's us add/remove tags from the
     * array of selected tags, essentially mimicking a checkbox.
     *
     * @return void
     */
    selected () {
      let value = clone(this.value)

      let existingIndex = findIndex(value, existing => existing.id === this.tag.id)

      // If we have an existing index in the array of selected tags and we deselected the
      // current tag then we'll splice it from the array.
      if (existingIndex !== -1) {
        if (!this.selected) {
          value.splice(existingIndex, 1)
        }

      // Otherwise, if we don't already have it, and we are selecting it, add it to the
      // array of selected tags.
      } else {
        if (this.selected) {
          value.push(this.tag)
        }
      }

      this.$emit('input', value)
    }
  },

  data () {
    return {
      selected: null
    }
  },

  computed: {
    vetted () {
      return this.tag.is_vetted
    },

    canManageTag () {
      return this.$userIsGlobalAdmin || (this.$userIsNonGlobalAdmin && this.$user.region_id === this.tag.region_id)
    }
  },

  methods: {
    handleDeleteTag () {
      this.$emit('delete', this.tag.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-group {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-left: 0.5em;
  padding-bottom: 0.5em;
  display: inline-block;
}
</style>
